export default __webpack_public_path__ + "static/media/PEEL.713c7396.png";